import { ExtendProps } from 'app';

type SocialActionLinkProps = {};
export default function SocialActionLink(
	props: ExtendProps<SocialActionLinkProps>
) {
	return (
		<div className="absolute -bottom-8 left-1/2 w-[60%] -translate-x-1/2 max-auto bg-primary-dark text-white rounded uppercase text-sm font-bold">
			{props.children}
		</div>
	);
}
